import { defineStore } from 'pinia';
import { ref } from 'vue';
import { CookieRestClient } from '@idem/common/rest/cookie-rest-client';
import { featureFlagFn } from '@idem/common/util/feature-flag-fn';

export const setupFeatureFlagsStore = () => {
  const rest = new CookieRestClient();
  const flags = ref<Record<string, boolean>>({});
  const esSuperusuario = ref(false);
  let carga: Promise<void> | undefined;

  async function leer() {
    const [featureFlags, perfil] = await Promise.all([rest.get('feature-flag'), rest.get('profile')]);
    flags.value = Object.fromEntries(
      featureFlags.map(featureFlag => [featureFlag.nombre, featureFlag.encendida]),
    );
    esSuperusuario.value = perfil.superusuario;
  }

  function cargar() {
    carga ??= leer();
    return carga;
  }

  function estaHabilitada(nombre: string): boolean {
    return featureFlagFn(nombre, { esSuperusuario: esSuperusuario.value }, flags.value);
  }

  return {
    flags,
    esSuperusuario,
    cargar,
    estaHabilitada,
  };
};

export const usarStoreFeatureFlags = defineStore('feature-flags', setupFeatureFlagsStore);
